import { FC } from 'react'
import { Link } from '@pogokid/mui'
import cx from 'classnames'
import styles from './Logo.module.css'

interface LogoProps {
  href?: string
  size?: 'small'
  hideName?: boolean
}

export const Logo: FC<LogoProps> = ({
  href,
  size,
  hideName,
}) => {
  return (
    <Link
      className={cx(styles.Logo, {
        [styles.isSizeLarge]: size !== 'small',
      })}
      href={href || '/'}
      color="inherit"
      variant="h6"
    >
      <img
        src="/soniq-favicon.svg"
        width={24}
        height={24}
        alt="Soniq Studio"
      />
      {!hideName && <span>Soniq Studio</span>}
    </Link>
  )
}
